import type { IAttributes, IAugmentedJQuery, IPromise, IScope, ITimeoutService } from "angular";
import { module } from "angular";
import $ from "jquery";

import "./irAnimateImage.html";
import "./irAnimateImage.scss";
import "./mmImage.html";

module("mmGui")
    .directive("animateSyncedSprites", [
        "$timeout",
        ($timeout: ITimeoutService) => {
            function link($scope: any, element: IAugmentedJQuery) {
                $scope.animation = {
                    sprite: new Date().getHours(),
                };

                let hourTimeoutId: IPromise<void>;
                const hourCounter = () => {
                    if (!$scope.animation.hovering) {
                        $scope.animation.sprite = (($scope.animation.sprite as number) + 1) % 24;
                    }
                    hourTimeoutId = $timeout(hourCounter, 400);
                };

                hourCounter();

                element.on("$destroy", () => {
                    $timeout.cancel(hourTimeoutId);
                });
            }

            return {
                link,
                restrict: "E",
            };
        },
    ])
    .directive("animateSingleSprite", [
        "$timeout",
        ($timeout: ITimeoutService) => {
            function link($scope: any, element: IAugmentedJQuery) {
                $scope.animation = {
                    sprite: 0,
                };

                let timeoutId: IPromise<void>;
                const counter = () => {
                    if (!$scope.animation.hovering) {
                        $scope.animation.sprite = (($scope.animation.sprite as number) + 1) % 4; // $scope.image.spritesCount;
                    }
                    timeoutId = $timeout(counter, 400);
                };

                counter();

                element.on("$destroy", () => {
                    $timeout.cancel(timeoutId);
                });
            }

            return {
                link,
                restrict: "E",
                // require: '^ngModel',
                // scope: {
                //    image: '=ngModel'
                // }
            };
        },
    ])
    .directive("mmImage", [
        () => {
            function link($scope: any, element: IAugmentedJQuery) {
                if (!$scope.animation) {
                    $scope.animation = {};
                }

                if ($scope.overlayImage && !$scope.overlaySpriteIndex) {
                    $scope.overlaySpriteIndex = 0;
                }

                const $image = element.find(".image");

                const ratio = (1.0 * $scope.image.width) / $scope.image.height;
                element.addClass("keep-ratio-container").css({ height: "auto" });
                $image.addClass("keep-ratio");
                $("<div />")
                    .css({ "padding-top": `${100.0 / ratio}%` })
                    .appendTo(element);

                element.css({ width: $scope.image.width });

                $scope.getBackgroundPosition = () => {
                    return `0 ${(-$image.width() * $scope.animation.sprite) / ratio}px`;
                };

                $scope.getOverlayBackgroundPosition = () => {
                    return `0 ${(-$image.width() * $scope.overlaySpriteIndex) / ratio}px`;
                };

                $scope.$watch("image", () => {
                    $image.css({ backgroundImage: `url(${$scope.image.url})` });
                });
                $scope.$watch("overlayImage", () => {
                    if (!$scope.overlayImage) {
                        return;
                    }
                    $image.find(".image-overlay").css({ backgroundImage: `url(${$scope.overlayImage.url})` });
                });

                $image
                    .hover(
                        () => {
                            $scope.$apply(() => {
                                $scope.animation.hovering = true;
                            });
                        },
                        () => {
                            $scope.$apply(() => {
                                $scope.animation.hovering = false;
                            });
                        },
                    )
                    .on("mousemove", (el) => {
                        const imageElement = document.getElementsByTagName("mm-image").item(0);
                        const parentOffset = imageElement.getBoundingClientRect();

                        const x = el.pageX - parentOffset.left;
                        // eslint-disable-next-line @typescript-eslint/no-unused-vars
                        const y = el.pageY - parentOffset.top;

                        $scope.$apply(() => {
                            $scope.animation.sprite = Math.floor(($scope.image.spritesCount * x) / parentOffset.width);
                        });
                    });
            }

            return {
                link,
                require: "^ngModel",
                restrict: "E",
                scope: {
                    animation: "=?",
                    image: "=ngModel",
                    imageCaption: "=",
                    imageTitle: "=",
                    overlayImage: "=?",
                    overlaySpriteIndex: "=?",
                    ratio: "=?",
                    showCaption: "=?",
                },
                templateUrl: "/App/Modules/Gui/Components/Image/mmImage.html",
            };
        },
    ])
    .directive("irAnimateImage", [
        () => {
            function link($scope: any, element: IAugmentedJQuery) {
                const $image = element.find(".image");

                const ratio = (1.0 * $scope.image.width) / $scope.image.height;
                element.addClass("keep-ratio-container").css({ height: "auto" });
                $image.addClass("keep-ratio");
                $("<div />")
                    .css({ "padding-top": `${100.0 / ratio}%` })
                    .appendTo(element);

                element.css({ width: $scope.image.width });

                $scope.imgError = () => {
                    $scope.hasError = true;
                    $scope.onerror();
                };

                $scope.$watch("image", () => {
                    $image.css({ backgroundImage: `url(${$scope.image.url})` });
                });
            }

            return {
                link,
                require: "^ngModel",
                restrict: "E",
                scope: {
                    image: "=ngModel",
                    imageCaption: "=?",
                    imageTitle: "=?",
                    onerror: "&",
                    ratio: "=?",
                    showCaption: "=?",
                },
                templateUrl: "/App/Modules/Gui/Components/Image/irAnimateImage.html",
            };
        },
    ])
    .directive("backgroundImage", () => (scope: IScope, element: IAugmentedJQuery, attrs: IAttributes) => {
        const setBgURL = () => {
            const url = attrs.backgroundImage;
            element.css({
                "background-image": `url(${url})`,
                "background-size": "cover",
            });
        };
        attrs.$observe("backgroundImage", () => {
            // Image has changed, reflect changes
            setBgURL();
        });
        // run when init as well
        setBgURL();
    });
